<template>
    <div>
        <page-header :user="user"></page-header>
        <main role="role">
            <page-speaking-class></page-speaking-class>
        </main>
        <page-footer></page-footer>
        <v-dialog style="color: black; z-index: 99999;" height="auto" :scrollable="true" :click-to-close="false" />
    </div>
</template>

<script>
    import appMixin from '@/lib/AppBaseMixin.js';

    import Vue from 'vue'
    import PageHeader from '@/components/Elements/PageHeader.vue';
    import PageFooter from '@/components/Elements/PageFooter.vue';
    import PageSpeakingClass from '@/components/Pages/PageSpeakingClass.vue';

    import VModal from 'vue-js-modal';
    import 'vue-js-modal/dist/styles.css'
    Vue.use(VModal, { dialog: true });

    import axios from 'axios'
    import VueAxios from 'vue-axios'
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = process.env.VUE_APP_OLD_SERVER_BASE_URL;
    //Vue.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';

    Vue.use(Loading);

    export default {
        name: 'App',
        mixins: [appMixin],
        components: {
            PageSpeakingClass,
            PageHeader,
            PageFooter,
        },
        data: function () {
            return {
                isPhone: null,
            };
        },
        methods: {
            initData: function () {
            },
        },  // end of methods
        computed: {

        },
        mounted: function () {
            this.initData();
        },
        watch: {
        },
        created() {
        },
    }
</script>

<style>
</style>
